<template>
  <button v-if="active" type="button" class="wrapper-button">
    <slot />
  </button>
  <div v-else class="wrapper-text">
    <slot />
  </div>
</template>

<script setup lang="ts">
export interface Props {
  active?: boolean;
}

withDefaults(defineProps<Props>(), {
  active: true,
});
</script>
<style lang="scss" scoped>
.wrapper-button {
  padding: 4px 16px;
  transition: all 0.2s ease-in-out;
  height: 100%;

  &:hover {
    background-color: rgb(var(--v-theme-bg-accent));
  }
}

.wrapper-text {
  padding: 0 16px;
  height: 100%;
  display: flex;
  align-items: center;
}
</style>
